import { AnimatePresence, motion } from "motion/react";
import React from "react";
import { Variants } from "../../animations/variants";
import { useRotatingContent } from "../../hooks/use_rotating_content";
import { DeweyLogo } from "../../icons";
import { useConfig } from "../../providers/config_provider";

export default function Searching() {
  const { organization } = useConfig();
  const { strings } = organization;
  const { loadingMessages, loadingConfirmation } = strings;

  // Use the hook to figure out which message to display
  const content = useRotatingContent(loadingMessages, loadingConfirmation);

  return (
    <motion.div
      variants={Variants.FadeInDown}
      initial="initial"
      animate="animate"
      exit="exit"
      className="dewey--searching"
    >
      <div className="dewey--searching--loader">
        <DeweyLogo className="dewey--searching--loader--icon" />
      </div>
      <AnimatePresence mode="wait">
        <motion.p
          key={content}
          variants={Variants.TextRotation}
          initial="initial"
          animate="animate"
          exit="exit"
          className="dewey--searching--label"
        >
          {content}
        </motion.p>
      </AnimatePresence>
    </motion.div>
  );
}
